import { render, staticRenderFns } from "./WikiSourceEditor.vue?vue&type=template&id=4239e1f9&"
import script from "./WikiSourceEditor.vue?vue&type=script&lang=js&"
export * from "./WikiSourceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports